import React, { Component } from 'react';
import classNames from 'classnames';
import Link from 'corp/components/UI/IsomorphicLink/IsomorphicLink';
import Logo from 'design-system/ScaleLogo';
import logout from '@scale/frontend-lib/logout';
import { CorpJobCounts } from '@scale/shared/types/api/corp-api/corpJobs/CorpJobCounts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IS_FEDERAL } from '@scale/frontend-lib/constants';
import { IUserJson } from '@scale/shared/types/user';
import { DEFAULT_PROFILE_IMAGE } from '@scale/shared/defaults';
import NotificationsBadge from './NotificationsBadge';
import { INotificationSeverity } from '@scale/shared/types/notifications/notification';

export default class TopBar extends Component<{
  onClickSearch: () => void;
  jobCounts?: CorpJobCounts;
  user?: IUserJson;
  notificationCount?: Record<keyof typeof INotificationSeverity, number>;
  onToggleCollapsedNotifications?: () => void;
  isRemoAdmin?: boolean;
}> {
  render() {
    const user = this.props.user as IUserJson;
    let profile;
    if (user?.scaleProfile?.profileImageUrl && (user?.scaleProfile?.profileImageUrl).length !== 0) {
      profile = user?.scaleProfile?.profileImageUrl;
    } else {
      profile = DEFAULT_PROFILE_IMAGE;
    }

    return (
      <div className={classNames('corp-header', { remoAdmin: this.props.isRemoAdmin })}>
        {!this.props.isRemoAdmin && (
          <header>
            <Link className="scale-corp" href="/?v=1">
              <Logo />
              {IS_FEDERAL && <div>fed</div>}
              <div>corp</div>
            </Link>
          </header>
        )}
        <div className="search-bar" onClick={this.props.onClickSearch}>
          <div style={{ marginRight: '12px' }}>
            <FontAwesomeIcon icon="search" />
          </div>
          <div className="search-content">
            <div>Search an ID, email, project, course name...</div>
            <div className="shortcut">
              <span className="keySpan" style={{ marginRight: 4 }}>
                CMD
              </span>
              <span className="keySpan">K</span>
            </div>
          </div>
        </div>
        {!this.props.isRemoAdmin && (
          <div className="corp-header__name">
            <NotificationsBadge
              onToggleCollapsed={this.props.onToggleCollapsedNotifications}
              notificationCount={this.props.notificationCount}
            />
            <div className="corp-header__picture">
              <Link href={'/lookup/me'}>
                <img style={{ width: 40, borderRadius: 20 }} src={profile}></img>
              </Link>
            </div>
            <a className="corp-header__logout" onClick={() => logout('/corp/login')}>
              Logout
            </a>
          </div>
        )}
        <style jsx>{`
          .corp-header {
            position: fixed;
            top: ${IS_FEDERAL ? '18px' : 0};
            left: 0;
            right: 0;
            z-index: 10;
            height: 61px;
            padding: 0 32px;
            flex-grow: 0;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            color: white;
            background: black;
          }

          .corp-header.remoAdmin {
            justify-content: center;
            position: relative;
            padding: 0;
          }

          .corp-header__warning {
            margin-left: auto;
          }

          .corp-header__name {
            margin-left: auto;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
          }

          .corp-header__picture {
            margin: 0 10px;
          }

          .corp-header__logout {
            font-weight: bold;
            margin: 0;
            vertical-align: middle;
          }
          .search-bar {
            flex: 1;
            display: flex;
            align-items: center;
            cursor: pointer;
            height: 40px;
            max-width: 600px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.5);
            font-weight: normal;
            padding: 8px;
          }
          .search-bar :hover {
            background: #111;
          }
          .search-content {
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .keySpan {
            padding: 2px 4px;
            background: #333;
            border-radius: 4px;
            margin-left: 4px;
            color: white;
            font-size: 13px;
          }
          .shortcut {
            opacity: 0;
            transition: opacity 200ms ease-out;
          }
          .search-bar:hover .shortcut {
            opacity: 1;
          }
          header {
            flex-shrink: 0;
            height: 60px;
            background: black;
            width: 280px;
          }
          header :global(.scale-corp) {
            height: 100%;
            width: 150px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          }
          header :global(svg) {
            fill: white;
            width: 72px !important;
          }
          header div {
            font-weight: 500;
            font-size: 18px;
            color: var(--color-ScaleBlue);
            text-transform: uppercase;
            padding-left: 8px;
          }
        `}</style>
      </div>
    );
  }
}
